

const mutations = {
  SET_BONDS_BREAKDOWN(state, payload) {
    state.bondBreakdown = {
      holdings: {
        data: filterDataForBlueBar(payload.topIssuer.data).slice(0, 5),
        asOfDate: payload.topIssuer.asOfDate
      },
      sectors: {
        data: payload.bondsBreakdown.data,
        asOfDate: payload.bondsBreakdown.asOfDate
      },
      bondBreakdownChart: payload.bondBreakdownChart
    };
  }
};

const getters = {
  getBondbreakdown: state => state.bondBreakdown
};

function filterDataForBlueBar(array) {
  const returnArray = [];
  if (array) {
    array.forEach(item => {
      if (item.name && item.value) {
        returnArray.push({
          SubTypeName: item.name,
          DataValue: item.value
        });
      }
    });
  }
  return returnArray;
}

const state = {
  bondBreakdown: null
};

export default {
  state,
  getters,
  mutations
};
